import { render, staticRenderFns } from "./SplashCatalog.vue?vue&type=template&id=3389be6e&scoped=true&"
import script from "./SplashCatalog.vue?vue&type=script&lang=js&"
export * from "./SplashCatalog.vue?vue&type=script&lang=js&"
import style0 from "./SplashCatalog.vue?vue&type=style&index=0&id=3389be6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389be6e",
  null
  
)

export default component.exports